import { FC } from 'react';

export const LeftColumn: FC = ({ children }) => {
    return <div className='w-full md:w-2/3 flex flex-col'>{children}</div>;
};
